import { useSystemStore } from '../stores/SystemStore';

export const useAppConfig = () => {
	const serverConfig = useSystemStore(state => state.serverConfig);

	if (!serverConfig) {
		throw new Error('Config is empty!');
	}

	return serverConfig.appConfig!;
};
